<template>
  <div>
    <h1 class="page-header">Food Court</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Name KH <span class="text-danger">*</span></label>
              <input
                v-model="model.name_kh"
                class="form-control kh-font"
                :class="{ 'is-invalid': errors.has('name_kh') }"
                placeholder="Enter name KH"
              />
              <div class="invalid-feedback" v-if="errors.has('name_kh')">
                {{ errors.first('name_kh') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Name EN<span class="text-danger">*</span></label>
              <input
                v-model="model.name_en"
                class="form-control"
                :class="{ 'is-invalid': errors.has('name_en') }"
                placeholder="Enter name EN"
              />
              <div class="invalid-feedback" v-if="errors.has('name_en')">
                {{ errors.first('name_en') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Phone Number<span class="text-danger">*</span></label>
              <input
                v-model="model.phone"
                class="form-control"
                :class="{ 'is-invalid': errors.has('phone') }"
                placeholder="Enter phone number"
              />
              <div class="invalid-feedback" v-if="errors.has('phone')">
                {{ errors.first('phone') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="form-col-label control-label">Address<span class="text-danger">*</span></label>
              <textarea
                v-model="model.address"
                class="form-control"
                rows="2"
                :class="{ 'is-invalid': errors.has('address') }"
                placeholder="Enter food court address"
              ></textarea>
              <div class="invalid-feedback" v-if="errors.has('address')">
                {{ errors.first('address') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="btn btn-default mr-2" @click.prevent="cancel">
                Cancel
              </ts-button>
              <ts-button v-if="updating" class="btn btn-primary" :waiting="waiting" @click.prevent="update">
                Update
              </ts-button>
              <ts-button v-if="!updating" class="btn btn-primary" :waiting="waiting" @click.prevent="store">
                Save
              </ts-button>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetchData" @fetched="fetchData = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import DataTable from './table.vue'

export default {
  name: 'food-court-form',
  components: { DataTable },
  data() {
    return {
      model: {
        foodcourt_id: '',
        name_kh: '',
        name_en: '',
        phone: '',
        address: ''
      },
      errors: new Errors(),
      updating: false,
      waiting: false,
      fetchData: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('inventory/foodCourt', ['edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('inventory/foodCourt/store', Object.assign({}, this.model))
        .then(response => {
          this.fetchData = true
          this.waiting = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('inventory/foodCourt/update', Object.assign({}, this.model))
        .then(response => {
          this.fetchData = true
          this.waiting = false
          this.$toasted.success(response.message)
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    cancel() {
      this.fetchData = true
      this.updating = false
      this.$store.commit('inventory/foodCourt/SET_EDIT_DATA', {})
      this.$router.push({ name: 'food-court' })
      this.clearInput()
    },

    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.updating = true
        this.model.foodcourt_id = this.edit_data.foodcourt_id
        this.model.name_kh = this.edit_data.name_kh
        this.model.name_en = this.edit_data.name_en
        this.model.phone = this.edit_data.phone
        this.model.address = this.edit_data.address
      }
    },
    clearInput() {
      this.model.vendor_i = ''
      this.model.foodcourt_id = ''
      this.model.name_kh = ''
      this.model.name_en = ''
      this.model.phone = ''
      this.model.address = ''
    },
    clickBackURL() {
      this.$store.commit('inventory/foodCourt/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetchData = true
      this.updating = false
    }
  },
  watch: {
    edit_data: {
      handler() {
        if (!_.isEmpty(this.edit_data)) {
          this.setEditData()
        }
      },
      deep: true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('inventory/foodCourt/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
